import {
  ContestMetaDataInner,
  ContestMetaDataInnerTasksInner,
} from "@bandit-network/sdk-api";

export interface RewardData {
  id: string;
  type: string;
  count: number;
}

export interface Args {
  twitterAccountId?: string;
  twitterUsername?: string;
  twitterPostId?: string;
  channelUsername?: string;
}

export interface Access {}

export interface Task extends ContestMetaDataInnerTasksInner {}

export interface ModuleTask {
  moduleId: string;
  task: Task;
  isCompleted: boolean;
}

export interface QuestModule extends ContestMetaDataInner {}

export enum TaskType {
  X_LIKE = "twitter_like",
  X_REPOST = "twitter_retweet",
  X_FOLLOW = "twitter_follow",
  X_POST = "twitter_tweet",
  X_COMMENT = "twitter_comment",
  DISCORD_JOIN = "discord_join",
  TELEGRAM_JOIN = "telegram_join",
  EMAIL_VERIFY = "email_verify",
  EPNS_SUBSCRIPTION = "epns_subscription",
  GITCOIN_SCORE = "gitcoin_score",
  ONCHAIN_GRAPH = "onchain_graph",
  OFFCHAIN_REST_API = "offchain_rest_api",
  VISIT_WEBSITE = "visit_website",
  GIT_CONNECT = "git_connect",
}
